var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'icon btn-ai btn btn-sm btn-secondary': true,
        'disabled': _vm.disabled,
        'generating': _vm.generating
    },attrs:{"role":_vm.disabled ? '' : 'button'},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('span',{staticClass:"position-relative"},[_c('i',{class:['fi', _vm.icon]}),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars"},[_c('div',{staticClass:"item"},[_vm._v("★")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("★")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("★")])])
}]

export { render, staticRenderFns }